// designer-view.js

import $ from 'jquery';
import contentTemplate from 'designer/header-view.ejs';
import sequenceService from 'SequenceService.js';
import constants        from 'Constants.js';
import ContextMenuController from 'ContextMenuController.js';
import BaseMainView     from 'BaseMainView.js';
import pageCaptureController from 'PageCaptureController.js';
import groupController      from 'GroupController.js';
import listService          from 'ListService.js';
import eventBus             from 'EventBus.js';
import formService          from 'FormService.js';
import util                 from 'util/Util.js';
import MobileContextMenuController from "../controllers/MobileContextMenuController";
import quickHelp from 'QuickHelpView';

//=============================================================================
//
// Begin executing the top-level designer UI.
// (Maybe could be called "LayoutView")
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class DesignerView extends BaseMainView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.events = {
            'click #designerAddNewPage' : 'addNewPage',
            'click #designerAddGroup' : 'addGroup'
        };

        return this;
    }


    //==========================================================
    // Create a page, reopen the layout with it as the
    // current page.
    //==========================================================
    addNewPage( evt ) {
        formService.addPage();
        pageCaptureController.populateAllThumbnails();
        eventBus.trigger('showCanvas');
    }

    //==========================================================
    // Create a group which includes current selected objects.
    //==========================================================
    addGroup( evt ) {
        groupController.toggleGroup(listService.selected);
    }

    //==========================================================
    // Impose well-known DOM IDs for use by Q/A test automation.
    // JQuery is our friend.
    //==========================================================
    injectTestIds() {

        const selector = '.factory-widget-icon';
        const prefix = 'TBI_';

        super.injectTestIds( selector, prefix );


        const selector2 = '.factory-widget-text';
        const prefix2= 'TBT_';

        super.injectTestIds( selector2, prefix2 );

    }

    //==========================================================
    // Compose the page
    //==========================================================
    initPage(formProperties) {
      
        sequenceService.resetTabIndex();
        sequenceService.resetZIndex();

        this.listenTo(this.model, 'change', this.render);

        /*******
            TODO: This creates the menu, for now I am reusing the one for forms, 
            we need to create the right one for mobile
        *******/
        if (this.options.designer && this.options.designer === constants.KIND_MOBILE) {
            this.initMenu(constants.KIND_MOBILE);
        }
        else {
            this.initMenu(constants.KIND_LAYOUT);
        }

        if(listService.mainKind === constants.KIND_MOBILE) {
            this._contextMenu = new MobileContextMenuController().menu;
        } else {
            this._contextMenu = new ContextMenuController().menu;
        }

        this.initToolbarPane();       
        util.enableSaveOption();
        //this.initToolboxPane();
        /*******
            TODO: This displays the left ans right panels
        *******/
        if (this.options.designer  && this.options.designer === constants.KIND_MOBILE) {
            this.initEditorContent(constants.KIND_MOBILE, formProperties);            
        }
        else {
            this.initEditorContent(constants.KIND_LAYOUT, formProperties);            
        }
    }

    render(formProperties) {

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
        this.initPage(formProperties);

        this.injectTestIds();

        util.printHeader(listService.dashboardLayout.mainPanelView.model);

        const quickHelpView = new quickHelp({el:".quick-help-view", type: 'app', helpLink: ""});
        quickHelpView.render();

        this.delegateEvents();

        return this;
    }

    removeUnused() {
        if (this._contextMenu) {
        this._contextMenu.destroy();
        
        this._contextMenu.$menu.remove();
        this._contextMenu.$menuList.remove();
        this._contextMenu.$menuList.off();
        }
        
        $('.bootstrapMenu', this.$el).remove();

        super.removeUnused();
    }
    
    remove() {
        this._contextMenu.destroy();
        
        this._contextMenu.$menu.remove();
        this._contextMenu.$menuList.remove();
        this._contextMenu.$menuList.unbind();

        $('.bootstrapMenu', this.$el).remove();

        this.$el.empty();
        super.remove();
    }

}

export default DesignerView;
